import React, { useEffect, useState } from 'react';
import { Form, get, useForm } from 'react-hook-form';

import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import { Divider, FormControl, FormHelperText } from '@mui/material';
import { Input } from '@material-ui/core';
import moment from 'moment';
import { NUMBER_ONLY_REGEX } from '../constant';

import { getUserDetails, isValidDoctorSlotsAddition } from '../Helper/utils';


export const SlotsTimePicker = ({
    isEditing,
    durationKey,
    day,
    doctorSlots = [],
    setDoctorSlots,
    data,
    setTimePicker,
    providerId,
    makeFormDirty,
    parentId
}) => {

    const [input, setInput] = useState(false)

    const {
        control,
        handleSubmit,
        formState: { errors, isDirty, isValid },
        reset,
        getValues,
        setValue,
        setError,
        register,
        watch,
        trigger
    } = useForm({
        mode: 'onChange',

    });

    useEffect(() => {

        if (isEditing) {
            setInput(true);
            const existingValue = data[durationKey];
            const formattedStartTime = moment(existingValue.startTime, 'HH:mm').format('HH:mm');
            const formattedEndTime = moment(existingValue.endTime, 'HH:mm').format('HH:mm');
            setValue('from', formattedStartTime);
            setValue('to', formattedEndTime);
            setValue('booking', existingValue.totalSlots);
            setValue('slots', existingValue.split);
        }
    }, []);

    const submitSlots = () => {
        const userDetails = getUserDetails()
        const values = getValues();

        let startTime = moment(values.from, 'HH:mm');
        let endTime = moment(values.to, 'HH:mm');
        startTime = startTime.hours() * 60 + startTime.minutes();
        endTime = endTime.hours() * 60 + endTime.minutes();

        const slots = values.booking;
        const split = values.slots;

        const newSlots = {
            providerId: providerId,
            dayOfWeek: parseInt(day),
            startTime: startTime,
            endTime: endTime,
            totalSlots: slots,
            split: split,
            slots: slots,
            bucketType: "InClinicConsults",
            isHomeVisit: false,
            isActive: true,
            followStrictTimeCapping: true,
            createdBy: userDetails.userId,
            updatedBy: userDetails.userId,
            parentId: parentId
        }

        let newDoctorSlots;
        if (isEditing) {

            const deleteValue = data[durationKey];
            const time = moment(deleteValue.startTime, "HH:mm");
            const totalMinutes = time.hours() * 60 + time.minutes();

            newDoctorSlots = doctorSlots.filter((item) => {
                return !(item.startTime == totalMinutes && item.dayOfWeek === parseInt(day));
            });
            newDoctorSlots = [...newDoctorSlots, newSlots];
            setTimePicker(false);
        }
        else {
            newDoctorSlots = [...doctorSlots, newSlots];
        }
        const isNonOverlappingSlot = isValidDoctorSlotsAddition(newDoctorSlots, parseInt(day));
        if (!isNonOverlappingSlot) {
            setError('from',
                {
                    type: 'manual',
                    message: 'Slots should be non overlapping'
                });
            setError('to',
                {
                    type: 'manual',
                    message: 'Slots should be non overlapping'
                });
            return;
        }
        setDoctorSlots(newDoctorSlots);
        setInput(false);
        makeFormDirty();
    }

    const handleCancel = (e) => {
        e.preventDefault();
        reset();
        if (isEditing) setTimePicker(false);
        setInput(false);
    }

    return (
        <>
            {!input ?
                (
                    <div
                        className="w-full flex gap-2 justify-center align-center text-base font-semibold"
                        onClick={() => { setInput(true); }}
                        style={{ color: '#0066DC' }}
                    >
                        <img src="https://views.medibuddy.in/providerUi/assets/bluePlus.svg" height={24} width={24} alt="Add" />
                        Add Durations & Slots
                    </div>) :
                <div className="flex flex-col border border-[#DBE0E6] rounded-lg p-2 justify-center gap-6">

                    <div className="flex flex-row px-2 gap-4 ">
                        <input hidden
                            {...register('from',
                                {
                                    required: true,
                                    validate: {
                                        lessThanTo: (value) => {
                                            const toValue = watch('to');
                                            if (!toValue) return true;
                                            const fromTime = moment(value, 'HH:mm');
                                            const toTime = moment(toValue, 'HH:mm');
                                            return fromTime.isBefore(toTime) || 'Start time must be lesser than End Time';
                                        }
                                    },
                                }
                            )} />
                        <TextField
                            className=" w-full"
                            id="time1"
                            type="time"
                            label="From"
                            variant="standard"
                            defaultValue={getValues('from')}
                            onChange={(e) => { e.preventDefault(); setValue('from', e.target.value); trigger('to') }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            inputProps={{
                                step:
                                    300,
                            }}
                            slotsProps={
                                {
                                    htmlInput: 300
                                }
                            }
                            sx={{
                                border: 'none'
                            }}
                            error={!!errors.from}
                            helperText={errors.from?.message}
                        />

                        <input
                            hidden
                            {...register('to', {
                                required: 'To value is required',
                                validate: {
                                    greaterThanFrom: (value) => {
                                        const fromValue = watch('from');
                                        if (!fromValue) return true;
                                        const fromTime = moment(fromValue, 'HH:mm');
                                        const toTime = moment(value, 'HH:mm');
                                        return toTime.isAfter(fromTime) || 'End time must be greater than Start Time';
                                    },
                                },
                            })}
                        />
                        <TextField
                            className="w-full"
                            id="time2"
                            type="time"
                            label="To"
                            defaultValue={getValues('to')}
                            variant="standard"
                            onChange={(e) => { e.preventDefault(); setValue('to', e.target.value); trigger('from'); trigger("to") }}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            InputProps={{
                                step:
                                    300,
                            }}
                            sx={{
                                border: 'none'
                            }}
                            error={!!errors.to}
                            helperText={errors.to?.message}
                        />
                    </div>
                    <div className="flex flex-row justify-between  px-2  gap-4">

                        <FormControl variant="standard" error={!!errors.booking}>
                            <FormHelperText sx={{ fontSize: '14px' }} >No. of Bookings</FormHelperText>
                            <input type="number" hidden
                                {...register('booking', {
                                    required: "Mandatory Information",
                                    valueAsNumber: true,
                                    validate: {
                                        greaterThanZero: (value) => {
                                            return value > 0 || 'Must be greater than 0';
                                        },
                                        smallerThan60: (value) => {
                                            if (value)
                                                return value < 101 || 'Must be less than 100';
                                        },
                                    },
                                   
                                })}
                            />
                            <Input
                                id="standard-adornment-weight"
                                placeholder='x'
                                type='number'
                                defaultValue={getValues('booking')}
                                endAdornment={<InputAdornment position="end">slots</InputAdornment>}
                                aria-describedby="standard-weight-helper-text"
                                inputProps={{
                                    'aria-label': 'weight',
                                }}
                                onChange={(e) => {
                                    e.preventDefault();
                                    const value = e.target.value;
                                    if (!NUMBER_ONLY_REGEX.test(value)) {
                                        setError('booking', {
                                            type: 'manual',
                                            message: "Invalid Input",
                                        });
                                    }
                                    else {
                                        trigger('from');
                                        setValue('booking', e.target.value, { shouldValidate: true, shouldDirty: true });
                                    }
                                }
                                }
                            />
                            <FormHelperText id="standard-weight-helper-text">{errors?.booking?.message}</FormHelperText>
                        </FormControl>

                        <FormControl variant="standard" error={!!errors?.slots} >
                            <FormHelperText className='text-sm' sx={{ fontSize: '14px' }}>Avg. Slot Time</FormHelperText>
                            <input type="number" hidden
                                {...register('slots', {
                                    required: "Mandatory Information",
                                    valueAsNumber: true,
                                    validate: {
                                        greaterThanZero: (value) => {
                                            return value > 0 || 'Must be greater than 0';
                                        },
                                        smallerThan60: (value) => {
                                            if (value)
                                                return value < 61 || 'Must be less than 60';
                                        }
                                    }
                                })}
                            />
                            <Input
                                id="standard-adornment-weight"
                                type='number'
                                maxmimum={60}
                                defaultValue={getValues('slots')}
                                placeholder='y'
                                endAdornment={<InputAdornment position="end">min</InputAdornment>}
                                aria-describedby="standard-weight-helper-text"
                                inputProps={{
                                    'aria-label': 'weight',
                                }}
                                error={errors.slots}
                                onChange={(e) => { 
                                    e.preventDefault();
                                    const value = e.target.value;
                                    if (!NUMBER_ONLY_REGEX.test(value)) {
                                        setError('slots', {
                                            type: 'manual',
                                            message: "Invalid Input",
                                        });
                                    }
                                    else {
                                        setValue('slots', e.target.value, { shouldValidate: true, shouldDirty: true });
                                        trigger("from")
                                    }
                                }}
                            />
                            <FormHelperText id="standard-weight-helper-text">{errors?.slots?.message}</FormHelperText>
                        </FormControl>


                    </div>
                    <Divider variant='middle' />
                    <div className="flex flex-row justify-between px-4 ">
                        <button className="flex py-2 gap-2 border border-[#DBE0E6] rounded-xl font-semibold "
                            style={{ padding: "0.5rem 3.75rem" }}
                            onClick={handleCancel}>
                            Cancel
                        </button>

                        <button className={` flex px-10 py-2 gap-2 border font-semibold rounded-xl ${isValid ? " bg-[#0066DC] text-white  " : " bg-[#F5F7F8] text-[#A4B0C0] "} `}
                            style={{ padding: "0.5rem 3.75rem" }}
                            onClick={handleSubmit(submitSlots)} >
                            Apply
                        </button>
                    </div>
                </div>
            }


        </>

    );
};


